var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUpload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 20,
    viewBox: "0 0 18 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.85759 1.27649C9.38326 0.812601 8.61295 0.812601 8.13862 1.27649L3.28147 6.02672C2.80714 6.49061 2.80714 7.24397 3.28147 7.70786C3.7558 8.17175 4.52612 8.17175 5.00045 7.70786L7.78571 4.9839V12.8032C7.78571 13.4601 8.32835 13.9908 9 13.9908C9.67165 13.9908 10.2143 13.4601 10.2143 12.8032V4.9839L12.9996 7.70786C13.4739 8.17175 14.2442 8.17175 14.7185 7.70786C15.1929 7.24397 15.1929 6.49061 14.7185 6.02672L9.86138 1.27649H9.85759ZM2.92857 13.9908C2.92857 13.3339 2.38594 12.8032 1.71429 12.8032C1.04263 12.8032 0.5 13.3339 0.5 13.9908V16.3659C0.5 18.3328 2.1317 19.9286 4.14286 19.9286H13.8571C15.8683 19.9286 17.5 18.3328 17.5 16.3659V13.9908C17.5 13.3339 16.9574 12.8032 16.2857 12.8032C15.6141 12.8032 15.0714 13.3339 15.0714 13.9908V16.3659C15.0714 17.0228 14.5288 17.5535 13.8571 17.5535H4.14286C3.47121 17.5535 2.92857 17.0228 2.92857 16.3659V13.9908Z",
    fill: "#1A2021"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpload);
export default __webpack_public_path__ + "static/media/upload.c99716655df190e637d34798246cf35c.svg";
export { ForwardRef as ReactComponent };